export const PAYMENT_SUCCESSFUL = "CLO";
export const AWAITING_PAYMENT = "ACT";
export const CANCELED_BY_MERCHENT_OR_CUSTOMER_BANK = "CAN";
export const EXPIRED = "EXP";

export const ON_CHECKOUT_PAYMENT_SUCCESS = "onCheckoutPaymentSuccess";
export const ON_CHECKOUT_FAILURE = "onCheckoutFailure";
export const ON_CHECKOUT_PAYMENT_FAILURE = "onCheckoutPaymentFailure";
export const ON_LOADING = "onLoading";
